import React, { useEffect} from "react";
import { Card } from "antd";
import { connect } from "react-redux";
import { getEmployeeAwardDashboard } from "../../../../../redux/employeeaward/employeeAwardState";
import { Send, Sparkles, Trophy } from "lucide-react";


const AwardStatusCard = ({ dashboardStats, getDashboard }) => {

  
  useEffect(() => {
    getDashboard();
  }, [getDashboard]);

  const awardStatus = [
    {
      title: "My Nominations (Month)",
      icon: Send,
      count: dashboardStats?.my_nominations || 0,
      color: "emerald-white",
    },
    {
      title: "Pending Reviews",
      icon: Sparkles,
      count: dashboardStats?.pending_reviews || 0,
      color: "purple-white",
    },
    {
      title: "Total Awards (Month)",
      icon: Trophy,
      count: dashboardStats?.total_awards || 0,
      color: "amber-white",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {awardStatus.map((item) => {
        const Icon = item.icon;
        return(
          <Card
          key={item.id}
          className={`rounded-xl card-border-s ${item.color}`}
        >
          <div className="flex items-center justify-between"> 
            <div>
              <p className="text-[12px] title-text mb-1">{item.title}</p>
              <p className="text-[24px] font-semibold card-text">{item.count}</p>
            </div>
            <div className="icon-theme p-3 rounded-xl">
              <Icon className="w-6 h-6" />
            </div>
          </div>
        </Card>   
        );
      })}
    </div>
  );
};

const mapStateToProps = (state) => ({
  dashboardStats: state.employeeAward.dashboardStats?.data,
});

const mapDispatchToProps = (dispatch) => ({
  getDashboard: () => dispatch(getEmployeeAwardDashboard()),
  
});

export default connect(mapStateToProps, mapDispatchToProps)(AwardStatusCard);
